import type { Answers } from '@/redux/slider';
import axios from 'axios';
import { getIustaOvmLinkUrl } from '@/components/landing-page/utils/functions';

export interface IustaOvmLinkResult {
  ready: boolean;
  url?: string;
}

/**
 * Applies the same appendPoaToCTA search-param logic goToSosOvm always used, but on top of an
 * arbitrary IUSTA-provided URL (which — unlike the old fixed OVM base URL — may have its own
 * path/query already, e.g. a personal link segment), so it must be preserved rather than
 * discarded.
 */
export function buildOvmClickoutUrl(rawUrl: string, appendPoaToCTA: boolean, answersDirect: Answers): string {
  const url = new URL(rawUrl);
  const shouldAppendPoa = appendPoaToCTA && answersDirect.legal_insurance === 'Ja';
  const search = shouldAppendPoa ? `${url.search}${url.search ? '&' : '?'}poa=insurance` : url.search;
  return `${url.origin}${url.pathname}${search}${url.hash}`;
}

/**
 * Checks whether IUSTA has generated the OVM link yet (custom field 24448 on the lead's Case).
 * Never throws — a network/parse failure is treated the same as "not ready yet" so callers can
 * keep polling without special-casing errors.
 */
export async function fetchIustaOvmLink(leadId: string): Promise<IustaOvmLinkResult> {
  try {
    const response = await axios.get(`${getIustaOvmLinkUrl()}?leadId=${encodeURIComponent(leadId)}`);
    const data = response.data;
    return data && data.ready && data.url ? { ready: true, url: data.url } : { ready: false };
  } catch {
    return { ready: false };
  }
}
